import BaseApi from './BaseApi';

export interface ITask {
    // tslint:disable-next-line
    getAll(): Promise<any>;
}

export default class Task extends BaseApi implements ITask {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public getAll() {
        return new Promise((resolve, reject) => {
            resolve([]);
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Task.ts